<div class="button-grid">
  <div class="button-grid__item" *hasRole="withdrawWithDocumentRoles">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonBackground]="CardButtonBackground.Tertiary"
      [buttonIcon]="['fas', 'receipt']"
      (clicked)="showWithdrawWithDocument()">
      {{ 'webPos.WithdrawWithDocument' | translate }}
    </app-card-button>
  </div>
  <div class="button-grid__item">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonBackground]="CardButtonBackground.Tertiary"
      [buttonIcon]="['fas', 'money-bill-wave']"
      (clicked)="showDeposit()">
      {{ 'webPos.Deposit' | translate }}
    </app-card-button>  
  </div>
  <div class="button-grid__item">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonBackground]="CardButtonBackground.Tertiary"
      [buttonIcon]="['fas', 'hand-holding-dollar']"
      (clicked)="showWithdraw()">
      {{ 'webPos.Withdraw' | translate }}
    </app-card-button>
  </div>
  <div class="button-grid__item">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonBackground]="CardButtonBackground.Tertiary"
      [buttonIcon]="['fas', 'ticket']"
      (clicked)="showVoucherExchange()">
      {{ 'webPos.VoucherExchange.Title' | translate }}
    </app-card-button>
  </div>
</div>

@switch (activeForm) {
  @case ("deposit") {
    <app-deposit (onClose)="hideActiveForm()"></app-deposit>
  }

  @case ("withdraw") {
    <app-withdraw (onClose)="hideActiveForm()"></app-withdraw>
  }

  @case ("withdrawWithDocument") {
    <app-withdraw-with-document (onClose)="hideActiveForm()"></app-withdraw-with-document>
  }

  @case ("voucherExchange") {
    <app-voucher-exchange (onClose)="hideActiveForm()"></app-voucher-exchange>
  }
}
